function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

// ------------------------------------constants.js----------------------------------------Start------------------------------------------------
const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};
// ------------------------------------constants.js----------------------------------------End------------------------------------------------
// ------------------------------------pubsub.js----------------------------------------Start------------------------------------------------
let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    subscribers[eventName].forEach((callback) => {
      callback(data);
    });
  }
}

// ------------------------------------pubsub.js----------------------------------------Start------------------------------------------------
// ------------------------------------custom.js----------------------------------------Start------------------------------------------------

// ------------------------------------custom.js----------------------------------------Start------------------------------------------------

// ------------------------------------collsearch.js----------------------------------------Start------------------------------------------------
// <!-- collection title  -->
  
document.addEventListener('DOMContentLoaded', function () {
    console.log('DOM content loaded');

    // Handle search form submission
    function handleSearchFormSubmit(event) {
        event.preventDefault();
        const searchInput = event.target.querySelector('input[name="q"]');
        const searchQuery = searchInput?.value.trim();

        if (!searchQuery) return console.error('Search query is empty or search input not found.');

        const collectionHandle = searchQuery.toLowerCase().replace(/[^\w\s-]/g, '').replace(/\s+/g, '-');
        const collectionUrl = `/collections/${encodeURIComponent(collectionHandle)}`;
        const searchUrl = `/search?q=${encodeURIComponent(searchQuery)}&type=product&collection=all`;

        // Redirect based on collection existence
        fetch(collectionUrl).then(response => {
            window.location.href = response.ok ? collectionUrl : searchUrl;
        }).catch(() => window.location.href = searchUrl);
    }

    // Attach event listener to search forms
    ['form[action="/search"]', '.header__search details form[action="/search"]'].forEach(selector => {
        const form = document.querySelector(selector);
        form?.addEventListener('submit', handleSearchFormSubmit);
    });
});
// ------------------------------------collsearch.js----------------------------------------Start------------------------------------------------

// ------------------------------------recent-blog.js----------------------------------------Start------------------------------------------------
document.addEventListener("DOMContentLoaded", function () {
  let swiperInstance = null; // Store Swiper instance

  function initSwiper() {
    // Check if the window width is <= 768px for mobile view
    if (window.innerWidth <= 768) {
      // Initialize Swiper if it hasn't been initialized
      if (!swiperInstance) {
        swiperInstance = new Swiper(".blog-swiper", {
          slidesPerView: 1,
          spaceBetween: 10,
          autoplay: {
            delay: 10000,
            disableOnInteraction: false,
          },
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
          },
          loop: true,
        });
      }
    } else {
      // Destroy Swiper instance if it's been initialized and we're on desktop
      if (swiperInstance) {
        swiperInstance.destroy(true, true);
        swiperInstance = null;
      }
    }
  }

  // Initialize Swiper on page load
  initSwiper();

  // Re-initialize on window resize
  window.addEventListener("resize", function () {
    initSwiper();
  });
});


// ------------------------------------recent-blog.js----------------------------------------Start------------------------------------------------

// ------------------------------------animations.js----------------------------------------Start------------------------------------------------
const SCROLL_ANIMATION_TRIGGER_CLASSNAME = 'scroll-trigger';
const SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = 'scroll-trigger--offscreen';
const SCROLL_ZOOM_IN_TRIGGER_CLASSNAME = 'animate--zoom-in';
const SCROLL_ANIMATION_CANCEL_CLASSNAME = 'scroll-trigger--cancel';

// Scroll in animation logic
function onIntersection(elements, observer) {
  elements.forEach((element, index) => {
    if (element.isIntersecting) {
      const elementTarget = element.target;
      if (elementTarget.classList.contains(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME)) {
        elementTarget.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
        if (elementTarget.hasAttribute('data-cascade'))
          elementTarget.setAttribute('style', `--animation-order: ${index};`);
      }
      observer.unobserve(elementTarget);
    } else {
      element.target.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
      element.target.classList.remove(SCROLL_ANIMATION_CANCEL_CLASSNAME);
    }
  });
}

function initializeScrollAnimationTrigger(rootEl = document, isDesignModeEvent = false) {
  const animationTriggerElements = Array.from(rootEl.getElementsByClassName(SCROLL_ANIMATION_TRIGGER_CLASSNAME));
  if (animationTriggerElements.length === 0) return;

  if (isDesignModeEvent) {
    animationTriggerElements.forEach((element) => {
      element.classList.add('scroll-trigger--design-mode');
    });
    return;
  }

  const observer = new IntersectionObserver(onIntersection, {
    rootMargin: '0px 0px -50px 0px',
  });
  animationTriggerElements.forEach((element) => observer.observe(element));
}

// Zoom in animation logic
function initializeScrollZoomAnimationTrigger() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const animationTriggerElements = Array.from(document.getElementsByClassName(SCROLL_ZOOM_IN_TRIGGER_CLASSNAME));

  if (animationTriggerElements.length === 0) return;

  const scaleAmount = 0.2 / 100;

  animationTriggerElements.forEach((element) => {
    let elementIsVisible = false;
    const observer = new IntersectionObserver((elements) => {
      elements.forEach((entry) => {
        elementIsVisible = entry.isIntersecting;
      });
    });
    observer.observe(element);

    element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));

    window.addEventListener(
      'scroll',
      throttle(() => {
        if (!elementIsVisible) return;

        element.style.setProperty('--zoom-in-ratio', 1 + scaleAmount * percentageSeen(element));
      }),
      { passive: true }
    );
  });
}

function percentageSeen(element) {
  const viewportHeight = window.innerHeight;
  const scrollY = window.scrollY;
  const elementPositionY = element.getBoundingClientRect().top + scrollY;
  const elementHeight = element.offsetHeight;

  if (elementPositionY > scrollY + viewportHeight) {
    // If we haven't reached the image yet
    return 0;
  } else if (elementPositionY + elementHeight < scrollY) {
    // If we've completely scrolled past the image
    return 100;
  }

  // When the image is in the viewport
  const distance = scrollY + viewportHeight - elementPositionY;
  let percentage = distance / ((viewportHeight + elementHeight) / 100);
  return Math.round(percentage);
}

window.addEventListener('DOMContentLoaded', () => {
  initializeScrollAnimationTrigger();
  initializeScrollZoomAnimationTrigger();
});

if (Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => initializeScrollAnimationTrigger(event.target, true));
  document.addEventListener('shopify:section:reorder', () => initializeScrollAnimationTrigger(document, true));
}

// ------------------------------------animations.js----------------------------------------Start------------------------------------------------

// ------------------------------------quantity-popover.js----------------------------------------Start------------------------------------------------
if (!customElements.get('quantity-popover')) {
  customElements.define(
    'quantity-popover',
    class QuantityPopover extends HTMLElement {
      constructor() {
        super();
        this.mql = window.matchMedia('(min-width: 990px)');
        this.mqlTablet = window.matchMedia('(min-width: 750px)');
        this.infoButtonDesktop = this.querySelector('.quantity-popover__info-button--icon-only');
        this.infoButtonMobile = this.querySelector('.quantity-popover__info-button--icon-with-label');
        this.popoverInfo = this.querySelector('.quantity-popover__info');
        this.closeButton = this.querySelector('.button-close');
        this.variantInfo = this.querySelector('.quantity-popover-container');
        this.eventMouseEnterHappened = false;

        if (this.closeButton) {
          this.closeButton.addEventListener('click', this.closePopover.bind(this));
        }

        if (this.popoverInfo && this.infoButtonDesktop && this.mql.matches) {
          this.popoverInfo.addEventListener('mouseenter', this.closePopover.bind(this));
        }

        if (this.infoButtonDesktop) {
          this.infoButtonDesktop.addEventListener('click', this.togglePopover.bind(this));
          this.infoButtonDesktop.addEventListener('focusout', this.closePopover.bind(this));
        }

        if (this.infoButtonMobile) {
          this.infoButtonMobile.addEventListener('click', this.togglePopover.bind(this));
          this.infoButtonMobile.addEventListener('focusout', this.closePopover.bind(this));
        }

        if (this.infoButtonDesktop && this.mqlTablet.matches) {
          this.variantInfo.addEventListener('mouseenter', this.togglePopover.bind(this));
          this.variantInfo.addEventListener('mouseleave', this.closePopover.bind(this));
        }
      }

      togglePopover(event) {
        event.preventDefault();
        if (event.type === 'mouseenter') {
          this.eventMouseEnterHappened = true;
        }

        if (event.type === 'click' && this.eventMouseEnterHappened) return;

        const button = this.infoButtonDesktop && this.mql.matches ? this.infoButtonDesktop : this.infoButtonMobile;
        const isExpanded = button.getAttribute('aria-expanded') === 'true';

        button.setAttribute('aria-expanded', !isExpanded);

        this.popoverInfo.toggleAttribute('hidden');

        const isOpen = button.getAttribute('aria-expanded') === 'true';

        button.classList.toggle('quantity-popover__info-button--open');

        if (isOpen && event.type !== 'mouseenter') {
          button.focus();
        }
      }

      closePopover(event) {
        event.preventDefault();
        const isChild = this.variantInfo.contains(event.relatedTarget);

        const button = this.infoButtonDesktop && this.mql.matches ? this.infoButtonDesktop : this.infoButtonMobile;

        if (!event.relatedTarget || !isChild) {
          button.setAttribute('aria-expanded', 'false');
          button.classList.remove('quantity-popover__info-button--open');
          this.popoverInfo.setAttribute('hidden', '');
        }

        this.eventMouseEnterHappened = false;
      }
    }
  );
}

// ------------------------------------quantity-popover.js----------------------------------------Start------------------------------------------------




document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});


let clickedMenu = 0;
let details = document.querySelectorAll('[id^="Details-HeaderSubMenu"] summary')
details.forEach((detail) =>{
  detail.addEventListener('click', (event) => {
    details.forEach((detailClicked) =>{
      if(detailClicked.parentNode.hasAttribute('open')){
        clickedMenu++
      }
    })
    if(clickedMenu >= 1 ){
       details.forEach((detail) =>{
         if(detail.parentNode.hasAttribute('open')){
           detail.parentNode.removeAttribute('open')
            detail.setAttribute('aria-expanded', false);
         }
      }) 
    }
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });
}) 





const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    // -----------------------------------------------------------------------------------------------------------------------------------------------------
// Initial check for custom input value greater than 20
var qty = $("input.custom_enter.quantity__input").val();
if (qty > 20 && qty !== "") {
    $(".quantity__input").hide();  // Hide the dropdown
    $(".custom_enter.quantity__input").show();  // Show the custom input field
} else {
    $(".quantity__input").show();  // Show the dropdown
    $(".custom_enter.quantity__input").hide();  // Hide the custom input field    
}

// Handle change event for the custom input (manual entry)
$(document).on('input', 'input.custom_enter.quantity__input', function() {    
    var customQty = $(this).val();
    if (customQty > 20) {        
        $(".quantity__input").hide();  // Hide the dropdown
        $(".custom_enter.quantity__input").show();  // Show the custom input field
    } else {
        $(".quantity__input").show();  // Show the dropdown
        $(".custom_enter.quantity__input").hide();  // Hide the custom input field      
    }
});

// Handle change event for the quantity dropdown
$(document).on('change', 'select.quantity__input', function() {    
    if (this.value > 20) {      
        $(".quantity__input").hide();  // Hide the dropdown
        $(".custom_enter.quantity__input").show();  // Show the custom input field
    } else {
        $(".quantity__input").show();  // Show the dropdown
        $(".custom_enter.quantity__input").hide();  // Hide the custom input field        
    }
});
// -----------------------------------------------------------------------------------------------------------------------------------------------------
    
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();  
    // -----------------------------------------------------------------------------------------------------------------------------------------------------
    // Initial check for custom input value greater than 20
var qty = $("input.custom_enter.quantity__input").val();
if (qty > 20 && qty !== "") {  
    $(".quantity__input").hide();  // Hide the dropdown
    $(".custom_enter.quantity__input").show();  // Show the custom input field
} else {
    $(".quantity__input").show();  // Show the dropdown
    $(".custom_enter.quantity__input").hide();  // Hide the custom input field    
}

// Handle change event for the custom input (manual entry)
$(document).on('input', 'input.custom_enter.quantity__input', function() {    
    var customQty = $(this).val();
    if (customQty > 20) {
        $(".quantity__input").hide();  // Hide the dropdown
        $(".custom_enter.quantity__input").show();  // Show the custom input field
    } else {
        $(".quantity__input").show();  // Show the dropdown
        $(".custom_enter.quantity__input").hide();  // Hide the custom input field        
    }
});

// Handle change event for the quantity dropdown
$(document).on('change', 'select.quantity__input', function() {    
    if (this.value > 20) {        
        $(".quantity__input").hide();  // Hide the dropdown
        $(".custom_enter.quantity__input").show();  // Show the custom input field
    } else {
        $(".quantity__input").show();  // Show the dropdown
        $(".custom_enter.quantity__input").hide();  // Hide the custom input field        
    }
});
// -----------------------------------------------------------------------------------------------------------------------------------------------------
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(
      'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)'
    ).forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));

  }


  
  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange(event) {
    this.updateOptions();
    this.updateMasterId();
    this.updateSelectedSwatchValue(event);
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select, fieldset'), (element) => {
      if (element.tagName === 'SELECT') {
        return element.value;
      }
      if (element.tagName === 'FIELDSET') {
        return Array.from(element.querySelectorAll('input')).find((radio) => radio.checked)?.value;
      }
    });
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateSelectedSwatchValue({ target }) {
    const { name, value, tagName } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = this.querySelector(`[data-selected-dropdown-swatch="${name}"] > .swatch`);
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = this.querySelector(`[data-selected-swatch-value="${name}"]`);
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach((mediaGallery) =>
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true)
    );

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(elementList, availableValuesList) {
    elementList.forEach((element) => {
      const value = element.getAttribute('value');
      const availableElement = availableValuesList.includes(value);

      if (element.tagName === 'INPUT') {
        element.classList.toggle('disabled', !availableElement);
      } else if (element.tagName === 'OPTION') {
        element.innerText = availableElement
          ? value
          : window.variantStrings.unavailable_with_option.replace('[value]', value);
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(
      `${this.dataset.url}?variant=${requestedVariantId}&section_id=${
        this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        const volumePricingSource = html.getElementById(
          `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.getElementById(
          `Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);
        const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
        const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);

        if (volumeNote) volumeNote.classList.remove('hidden');
        if (volumePricingDestination) volumePricingDestination.classList.remove('hidden');
        if (qtyRules) qtyRules.classList.remove('hidden');

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle('hidden', pricePerItemSource.classList.contains('hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('hidden');

        if (inventoryDestination) inventoryDestination.classList.toggle('hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
    const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
    const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
    const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('hidden');
    if (inventory) inventory.classList.add('hidden');
    if (sku) sku.classList.add('hidden');
    if (pricePerItem) pricePerItem.classList.add('hidden');
    if (volumeNote) volumeNote.classList.add('hidden');
    if (volumeTable) volumeTable.classList.add('hidden');
    if (qtyRules) qtyRules.classList.add('hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);


// autoship
$(document).ready(function () {
  // Delegated event listener for "One-Time Purchase" button click
  $(document).on("click", ".kwik-purchase-card--onetime", function () {
    $(".product-form__submit").find("span").html('<span class="ats-cart">Add to Cart</span>');
    // Reset the background color when "One-Time Purchase" is selected
    $(".product-form__submit").css("background-color", "#e67326"); 
  });
  $(document).on("click", ".kwik-purchase-card--subscribe", function () {
   $(".product-form__submit").find("span").html(`
      Start 
      <img src="https://cdn.shopify.com/s/files/1/2229/1767/files/Group_286_AutoShip.png?v=1733208100" style="width:16px;">
      Autoship
    `);
  });

  // Delegated event listener for "Autoship" change event
  $(document).on("change", ".kwik-purchase-card--subscribe", function () {
    var selectedOption = $(this).val(); 
      if ($(window).width() >= 1024) {
        $('.info-product-btn').css({
            bottom: '215px',
            left: '285px'
        });
    }
    if ($(window).width() >= 310 && $(window).width() <= 767) {
        $('.info-product-btn').css({
            position: 'relative',
            'z-index': '99',
            top: '212px',
            left: '222px'
        });
    }
    

    // Change the background color for Autoship
    $(".product-form__submit").css("background-color", "#ff6600"); 
  });
});

// $(document).ready(function () {
//   setTimeout(function () {
//   $("#order_number_val").val(27296);
//   var getorderNumber = $("#order_number_val").val();
//   console.log(getorderNumber);
//   console.log("work for order retrun");
//    }, 2500);
// });

//  setTimeout(function () {
//   console.log("code_start");
// (function() {
//     const orderNumber = '27296';
//     const email = 'kwikretailnp@gmail.com';
    
//     console.log('⚛️ React-compatible auto-fill starting...');
    
//     // Function to set React input value (triggers React's onChange)
//     function setReactValue(element, value) {
//         if (!element) return false;
        
//         // Get React's internal instance
//         const valueSetter = Object.getOwnPropertyDescriptor(element, 'value')?.set ||
//                            Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value')?.set;
        
//         if (valueSetter) {
//             // Use React's setter
//             const prototype = Object.getPrototypeOf(element);
//             const prototypeValueSetter = Object.getOwnPropertyDescriptor(prototype, 'value')?.set;
            
//             if (prototypeValueSetter && valueSetter !== prototypeValueSetter) {
//                 prototypeValueSetter.call(element, value);
//             } else {
//                 valueSetter.call(element, value);
//             }
            
//             // Trigger React's synthetic events
//             element.dispatchEvent(new Event('input', { bubbles: true }));
//             element.dispatchEvent(new Event('change', { bubbles: true }));
//             element.dispatchEvent(new Event('blur', { bubbles: true }));
            
//             return true;
//         }
        
//         // Fallback method
//         element.value = value;
//         element.dispatchEvent(new Event('input', { bubbles: true }));
//         element.dispatchEvent(new Event('change', { bubbles: true }));
        
//         return true;
//     }
    
//     // Function to fill the form
//     function fillForm() {
//         let orderFilled = false;
//         let emailFilled = false;
        
//         // Find and fill order number
//         const orderInput = document.querySelector('input[id*="order"][id*="val"]:not([type="email"])') ||
//                           document.querySelector('input.Polaris-TextField__Input[type="text"]') ||
//                           document.querySelector('input[placeholder*="order" i]');
        
//         if (orderInput) {
//             setReactValue(orderInput, orderNumber);
//             console.log('✅ Order number filled:', orderNumber);
//             orderFilled = true;
//         }
        
//         // Find and fill email - specifically target the email input
//         const emailInput = document.querySelector('input#order_email_val') ||
//                           document.querySelector('input[type="email"].Polaris-TextField__Input') ||
//                           document.querySelector('input[type="email"]');
        
//         if (emailInput) {
//             setReactValue(emailInput, email);
//             console.log('✅ Email filled:', email);
//             emailFilled = true;
//         }
        
//         return orderFilled && emailFilled;
//     }
    
//     // Function to click submit button
//     function clickSubmit() {
//         // Look for Polaris button or any submit button
//         const buttons = document.querySelectorAll('button');
        
//         for (let btn of buttons) {
//             const text = btn.textContent.toLowerCase().trim();
//             if (text.includes('start') || text.includes('submit') || text.includes('continue')) {
//                 console.log('🎯 Clicking button:', btn.textContent.trim());
//                 btn.click();
//                 return true;
//             }
//         }
        
//         return false;
//     }
    
//     // Wait for Polaris form to load and fill it
//     function attemptFill(attempt = 1) {
//         // console.log(\'🔄 Fill attempt \${attempt}...\');
        
//         if (fillForm()) {
//             console.log('✅ Form filled successfully!');
            
//             // Auto-submit after 2 seconds
//             setTimeout(() => {
//                 if (clickSubmit()) {
//                     console.log('✅ Form submitted!');
//                 } else {
//                     console.log('⚠️ Submit button not found, please click manually');
//                 }
//             }, 2000);
            
//             return true;
//         } else if (attempt < 10) {
//             // Retry up to 10 times (5 seconds)
//             setTimeout(() => attemptFill(attempt + 1), 500);
//         } else {
//             console.log('❌ Could not find form fields after 10 attempts');
//         }
//     }
    
//     // Use MutationObserver to detect when form loads
//     const observer = new MutationObserver(() => {
//         const emailInput = document.querySelector('input#order_email_val');
//         if (emailInput) {
//             console.log('✅ Polaris form detected!');
//             observer.disconnect();
//             setTimeout(() => attemptFill(), 500);
//         }
//     });
    
//     observer.observe(document.body, {
//         childList: true,
//         subtree: true
//     });
    
//     // Also try immediately in case form is already loaded
//     setTimeout(() => attemptFill(), 1000);
    
//     console.log('✅ React auto-fill script loaded');
// })()
//  }, 2500);

// Viken comment code

// document.addEventListener('DOMContentLoaded', function () {
//   new Swiper('.sub-category-swiper', {
//     slidesPerView: 'auto', // Each slide takes its natural width
//     spaceBetween: 10,
//     freeMode: true, // Smooth drag like a scrollable row
//     grabCursor: true, // Shows grab cursor on desktop
//     scrollbar: {
//       el: '.sub-category-swiper .swiper-scrollbar',
//       draggable: true,
//       hide: false,
//     },
//     navigation: {
//       nextEl: '.sub-cat-wrapper .swiper-button-next',
//       prevEl: '.sub-cat-wrapper .swiper-button-prev',
//     },
//     breakpoints: {
//       0: {
//         slidesPerView: 'auto',
//         spaceBetween: 0,
//       },
//       768: {
//         slidesPerView: 'auto',
//         spaceBetween: 0,
//       },
//     },
//   });
// });
      
(function() {
    // Get parameters from URL
    const urlParams = new URLSearchParams(window.location.search);
    const orderNumber = urlParams.get('order_number') || '';
    const email = urlParams.get('email') || '';
    
    // Only run if we have both parameters
    if (!orderNumber || !email) {
        // console.log('⚠️ No order_number or email in URL');
        return;
    }
    
    // console.log('⚛️ Auto-fill starting with:', { orderNumber, email });
    
    let formFilled = false; // Flag to stop retrying once filled
    
    // Function to set React input value (triggers React's onChange)
    function setReactValue(element, value) {
        if (!element) return false;
        
        // Get React's internal instance
        const valueSetter = Object.getOwnPropertyDescriptor(element, 'value')?.set ||
                           Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value')?.set;
        
        if (valueSetter) {
            // Use React's setter
            const prototype = Object.getPrototypeOf(element);
            const prototypeValueSetter = Object.getOwnPropertyDescriptor(prototype, 'value')?.set;
            
            if (prototypeValueSetter && valueSetter !== prototypeValueSetter) {
                prototypeValueSetter.call(element, value);
            } else {
                valueSetter.call(element, value);
            }
            
            // Trigger React's synthetic events
            element.dispatchEvent(new Event('input', { bubbles: true }));
            element.dispatchEvent(new Event('change', { bubbles: true }));
            element.dispatchEvent(new Event('blur', { bubbles: true }));
            
            return true;
        }
        
        // Fallback method
        element.value = value;
        element.dispatchEvent(new Event('input', { bubbles: true }));
        element.dispatchEvent(new Event('change', { bubbles: true }));
        
        return true;
    }
    
    // Function to fill the form
    function fillForm() {
        // Skip if already filled
        if (formFilled) {
            return true;
        }
        
        let orderFilled = false;
        let emailFilled = false;
        
        // Find and fill order number
        const orderInput = document.querySelector('input[id*="order"][id*="val"]:not([type="email"])') ||
                          document.querySelector('input.Polaris-TextField__Input[type="text"]') ||
                          document.querySelector('input[placeholder*="order" i]');
        
        if (orderInput && !orderInput.value) {
            setReactValue(orderInput, orderNumber);
            console.log('✅ Order number filled:', orderNumber);
            orderFilled = true;
        } else if (orderInput && orderInput.value) {
            orderFilled = true; // Already has value
        }
        
        // Find and fill email - specifically target the email input
        const emailInput = document.querySelector('input#order_email_val') ||
                          document.querySelector('input[type="email"].Polaris-TextField__Input') ||
                          document.querySelector('input[type="email"]');
        
        if (emailInput && !emailInput.value) {
            setReactValue(emailInput, email);
            console.log('✅ Email filled:', email);
            emailFilled = true;
        } else if (emailInput && emailInput.value) {
            emailFilled = true; // Already has value
        }
        
        // Mark as filled if both fields are done
        if (orderFilled && emailFilled) {
            formFilled = true;
            console.log('✅ Form completely filled! Stopping retries.');
            return true;
        }
        
        return false;
    }
    
    // Function to click submit button (optional)
    function clickSubmit() {
        const buttons = document.querySelectorAll('button');
        
        for (let btn of buttons) {
            const text = btn.textContent.toLowerCase().trim();
            if (text.includes('start') || text.includes('submit') || text.includes('continue')) {
                console.log('🎯 Clicking button:', btn.textContent.trim());
                btn.click();
                return true;
            }
        }
        
        return false;
    }
    
    // Wait for Parcel Panel form to load and fill it
    function attemptFill(attempt = 1) {
        // Stop if already filled
        if (formFilled) {
            return;
        }
        
        console.log(`🔄 Fill attempt ${attempt}...`);
        
        if (fillForm()) {
            console.log('✅ Form filled successfully!');
            
            // Optional: Auto-submit after 2 seconds
            // Uncomment if you want auto-submit
            /*
            setTimeout(() => {
                if (clickSubmit()) {
                    console.log('✅ Form submitted!');
                } else {
                    console.log('⚠️ Submit button not found');
                }
            }, 2000);
            */
            
            return;
        } else if (attempt < 30) {
            // Keep retrying until form is filled (max 30 attempts = 15 seconds)
            setTimeout(() => attemptFill(attempt + 1), 500);
        } else {
            console.log('❌ Could not find or fill form fields after 30 attempts');
        }
    }
    
    // Use MutationObserver to detect when Parcel Panel form loads
    const observer = new MutationObserver(() => {
        if (formFilled) {
            observer.disconnect();
            return;
        }
        
        const emailInput = document.querySelector('input#order_email_val');
        const orderInput = document.querySelector('input[id*="order"][id*="val"]:not([type="email"])');
        
        if (emailInput && orderInput) {
            console.log('✅ Parcel Panel form detected!');
            attemptFill();
        }
    });
    
    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
    
    // Also try immediately in case form is already loaded
    setTimeout(() => attemptFill(), 1000);
    
    console.log('✅ Auto-fill script loaded and waiting for form...');
})();
    let accessibilitySettings = {
        fontSize: 'default',
        letterSpacing: 'normal',
        lineHeight: 'normal',
        textAlign: 'default',
        textColor: 'default',
        titleColor: 'default',
        backgroundColor: 'default',
        colorVision: 'none',
        contrast: 'normal',
        saturation: 'normal',
        cursor: 'default',
        readingLine: false,
        readingGuide: false,
        readingMask: false,
        textMagnifier: false,
        readableFont: false,
        underlineLinks: false,
        highlightTitles: false,
        highlightLinks: false,
        highlightHover: false,
        highlightFocus: false,
        stopAnimations: false,
        muteSounds: false,
        hideImages: false,
        readMode: false,
        textToSpeech: false,
        keyboardShortcuts: false,
        activeProfile: null,
      };

      let ttsUtterance = null;
      let ttsEnabled = false;

      function loadSettings() {
        try {
          const saved = localStorage.getItem('kwikpets_accessibility_settings');
          if (saved) {
            accessibilitySettings = { ...accessibilitySettings, ...JSON.parse(saved) };
            applyAllSettings();
          }
        } catch (e) {
          console.warn('Could not load accessibility settings');
        }
      }

      function saveSettings() {
        try {
          localStorage.setItem('kwikpets_accessibility_settings', JSON.stringify(accessibilitySettings));
        } catch (e) {
          console.warn('Could not save accessibility settings');
        }
      }

      function applyAllSettings() {
        setFontSize(accessibilitySettings.fontSize, true);
        setLetterSpacing(accessibilitySettings.letterSpacing, true);
        setLineHeight(accessibilitySettings.lineHeight, true);
        setTextAlign(accessibilitySettings.textAlign, true);
        setTextColor(accessibilitySettings.textColor, true);
        setTitleColor(accessibilitySettings.titleColor, true);
        setBackgroundColor(accessibilitySettings.backgroundColor, true);
        setColorVision(accessibilitySettings.colorVision, true);
        setContrast(accessibilitySettings.contrast, true);
        setSaturation(accessibilitySettings.saturation, true);
        setCursor(accessibilitySettings.cursor, true);

        if (accessibilitySettings.readingLine) enableReadingLine();
        if (accessibilitySettings.readingGuide) enableReadingGuide();
        if (accessibilitySettings.readingMask) enableReadingMask();
        if (accessibilitySettings.textMagnifier) enableTextMagnifier();
        if (accessibilitySettings.readableFont) enableReadableFont();
        if (accessibilitySettings.underlineLinks) enableUnderlineLinks();
        if (accessibilitySettings.highlightTitles) enableHighlightTitles();
        if (accessibilitySettings.highlightLinks) enableHighlightLinks();
        if (accessibilitySettings.highlightHover) enableHighlightHover();
        if (accessibilitySettings.highlightFocus) enableHighlightFocus();
        if (accessibilitySettings.stopAnimations) enableStopAnimations();
        if (accessibilitySettings.muteSounds) enableMuteSounds();
        if (accessibilitySettings.hideImages) enableHideImages();
        if (accessibilitySettings.readMode) enableReadMode();
        if (accessibilitySettings.textToSpeech) enableTextToSpeech();

        updateUIState();
      }

      function updateUIState() {
        document.querySelectorAll('[data-size]').forEach((btn) => {
          btn.classList.toggle('active', btn.dataset.size === accessibilitySettings.fontSize);
        });
        document.querySelectorAll('[data-spacing]').forEach((btn) => {
          btn.classList.toggle('active', btn.dataset.spacing === accessibilitySettings.letterSpacing);
        });
        document.querySelectorAll('[data-line]').forEach((btn) => {
          btn.classList.toggle('active', btn.dataset.line === accessibilitySettings.lineHeight);
        });
        document.querySelectorAll('[data-align]').forEach((btn) => {
          btn.classList.toggle('active', btn.dataset.align === accessibilitySettings.textAlign);
        });
        document.querySelectorAll('[data-text-color]').forEach((btn) => {
          btn.classList.toggle('active', btn.dataset.textColor === accessibilitySettings.textColor);
        });
        document.querySelectorAll('[data-title-color]').forEach((btn) => {
          btn.classList.toggle('active', btn.dataset.titleColor === accessibilitySettings.titleColor);
        });
        document.querySelectorAll('[data-bg-color]').forEach((btn) => {
          btn.classList.toggle('active', btn.dataset.bgColor === accessibilitySettings.backgroundColor);
        });
        document.querySelectorAll('[data-vision]').forEach((btn) => {
          btn.classList.toggle('active', btn.dataset.vision === accessibilitySettings.colorVision);
        });
        document.querySelectorAll('[data-contrast]').forEach((btn) => {
          btn.classList.toggle('active', btn.dataset.contrast === accessibilitySettings.contrast);
        });
        document.querySelectorAll('[data-saturation]').forEach((btn) => {
          btn.classList.toggle('active', btn.dataset.saturation === accessibilitySettings.saturation);
        });
        document.querySelectorAll('[data-cursor]').forEach((btn) => {
          btn.classList.toggle('active', btn.dataset.cursor === accessibilitySettings.cursor);
        });
        document.querySelectorAll('[data-profile]').forEach((card) => {
          card.classList.toggle('active', card.dataset.profile === accessibilitySettings.activeProfile);
        });

        document.getElementById('readingLineToggle').classList.toggle('active', accessibilitySettings.readingLine);
        document.getElementById('readingGuideToggle').classList.toggle('active', accessibilitySettings.readingGuide);
        document.getElementById('readingMaskToggle').classList.toggle('active', accessibilitySettings.readingMask);
        document.getElementById('textMagnifierToggle').classList.toggle('active', accessibilitySettings.textMagnifier);
        document.getElementById('readableFontToggle').classList.toggle('active', accessibilitySettings.readableFont);
        document
          .getElementById('underlineLinksToggle')
          .classList.toggle('active', accessibilitySettings.underlineLinks);
        document
          .getElementById('highlightTitlesToggle')
          .classList.toggle('active', accessibilitySettings.highlightTitles);
        document
          .getElementById('highlightLinksToggle')
          .classList.toggle('active', accessibilitySettings.highlightLinks);
        document
          .getElementById('highlightHoverToggle')
          .classList.toggle('active', accessibilitySettings.highlightHover);
        document
          .getElementById('highlightFocusToggle')
          .classList.toggle('active', accessibilitySettings.highlightFocus);
        document
          .getElementById('stopAnimationsToggle')
          .classList.toggle('active', accessibilitySettings.stopAnimations);
        document.getElementById('muteSoundsToggle').classList.toggle('active', accessibilitySettings.muteSounds);
        document.getElementById('hideImagesToggle').classList.toggle('active', accessibilitySettings.hideImages);
        document.getElementById('readModeToggle').classList.toggle('active', accessibilitySettings.readMode);
        document.getElementById('textToSpeechToggle').classList.toggle('active', accessibilitySettings.textToSpeech);
        document
          .getElementById('keyboardShortcutsToggle')
          .classList.toggle('active', accessibilitySettings.keyboardShortcuts);
        // Show/hide shortcut labels
        document.querySelectorAll('.profile-shortcut').forEach((shortcut) => {
          shortcut.classList.toggle('hidden', !accessibilitySettings.keyboardShortcuts);
        });
      }

      function toggleAccessibilitySidebar() {
        const sidebar = document.querySelector('.accessibility-sidebar');
        const overlay = document.querySelector('.sidebar-overlay');
        sidebar.classList.toggle('open');
        overlay.classList.toggle('active');
      }

      function closeAccessibilitySidebar() {
        const sidebar = document.querySelector('.accessibility-sidebar');
        const overlay = document.querySelector('.sidebar-overlay');
        sidebar.classList.remove('open');
        overlay.classList.remove('active');
      }

      
      function applyProfile(profile, fromKeyboard = false) {
          console.log('applyProfile called with:', profile, 'fromKeyboard:', fromKeyboard);
          
          // If called from keyboard shortcut, trigger the click
          if (fromKeyboard) {
            console.log('Triggered from keyboard, finding profile card');
            const profileCard = document.querySelector(`[data-profile="${profile}"]`);
            
            if (profileCard) {
              console.log('Found profile card, triggering click');
              profileCard.click();
              return; // Exit here
            } else {
              console.error('Profile card not found:', profile);
              return;
            }
          }
          
          // Regular click functionality (original code)
          console.log('Current active profile:', accessibilitySettings.activeProfile);
          
          // Toggle off if clicking same profile
          if (accessibilitySettings.activeProfile === profile) {
            console.log('Disabling profile:', profile);
            
            // Clear active profile
            accessibilitySettings.activeProfile = null;

            // Reset to defaults
            setFontSize('default', true);
            setLineHeight('normal', true);
            setLetterSpacing('normal', true);
            setContrast('normal', true);
            setSaturation('normal', true);
            setCursor('default', true);

            // Remove all classes
            document.body.classList.remove(
              'accessibility-readable-font',
              'accessibility-read-mode',
              'accessibility-stop-animations',
              'accessibility-underline-links',
              'accessibility-highlight-focus',
              'accessibility-big-cursor-black',
              'accessibility-big-cursor-white',
              'accessibility-high-contrast',
              'accessibility-low-saturation'
            );
            
            // Disable reading tools
            const readingLine = document.getElementById('readingLine');
            const readingGuide = document.getElementById('readingGuide');
            const readingMask = document.getElementById('readingMask');
            const textMagnifier = document.getElementById('textMagnifier');
            const ttsControls = document.getElementById('ttsControls');
            
            if (readingLine) {
              readingLine.classList.remove('active');
              document.removeEventListener('mousemove', updateReadingLine);
            }
            if (readingGuide) {
              readingGuide.classList.remove('active');
              document.removeEventListener('mousemove', updateReadingGuide);
            }
            if (readingMask) {
              readingMask.classList.remove('active');
              document.removeEventListener('mousemove', updateReadingMask);
            }
            if (textMagnifier) {
              textMagnifier.classList.remove('active');
              document.removeEventListener('mousemove', updateTextMagnifier);
            }
            if (ttsControls) {
              ttsControls.classList.remove('active');
            }
            
            // Stop TTS
            if (window.speechSynthesis) {
              window.speechSynthesis.cancel();
            }
            ttsEnabled = false;
            
            // Update settings
            accessibilitySettings.readableFont = false;
            accessibilitySettings.readMode = false;
            accessibilitySettings.stopAnimations = false;
            accessibilitySettings.underlineLinks = false;
            accessibilitySettings.highlightFocus = false;
            accessibilitySettings.textToSpeech = false;
            accessibilitySettings.readingMask = false;

            saveSettings();
            updateUIState();
            return;
          }

          console.log('Enabling profile:', profile);
          
          // Clean up previous profile if exists
          if (accessibilitySettings.activeProfile) {
            document.body.classList.remove(
              'accessibility-font-size-20',
              'accessibility-font-size-25',
              'accessibility-font-size-30',
              'accessibility-font-size-35',
              'accessibility-letter-spacing-1',
              'accessibility-letter-spacing-2',
              'accessibility-letter-spacing-3',
              'accessibility-letter-spacing-4',
              'accessibility-line-height-1-5',
              'accessibility-line-height-1-8',
              'accessibility-line-height-2',
              'accessibility-readable-font',
              'accessibility-read-mode',
              'accessibility-stop-animations',
              'accessibility-underline-links',
              'accessibility-highlight-focus',
              'accessibility-big-cursor-black',
              'accessibility-big-cursor-white',
              'accessibility-high-contrast',
              'accessibility-low-saturation'
            );
          }

          // Set new active profile
          accessibilitySettings.activeProfile = profile;

          // Apply profile settings
          switch (profile) {
            case 'reader':
              setFontSize('25', true);
              setLineHeight('1.8', true);
              document.body.classList.add('accessibility-readable-font');
              document.body.classList.add('accessibility-read-mode');
              accessibilitySettings.readableFont = true;
              accessibilitySettings.readMode = true;
              break;
              
            case 'blind':
              document.body.classList.add('accessibility-stop-animations');
              document.body.classList.add('accessibility-underline-links');
              document.body.classList.add('accessibility-highlight-focus');
              document.getElementById('ttsControls').classList.add('active');
              ttsEnabled = true;
              accessibilitySettings.stopAnimations = true;
              accessibilitySettings.underlineLinks = true;
              accessibilitySettings.highlightFocus = true;
              accessibilitySettings.textToSpeech = true;
              break;
              
            case 'seizure':
              setContrast('normal', true);
              setSaturation('low', true);
              document.body.classList.add('accessibility-stop-animations');
              accessibilitySettings.stopAnimations = true;
              break;
              
            case 'adhd':
              const readingMask = document.getElementById('readingMask');
              readingMask.classList.add('active');
              document.addEventListener('mousemove', updateReadingMask);
              document.body.classList.add('accessibility-stop-animations');
              document.body.classList.add('accessibility-read-mode');
              accessibilitySettings.readingMask = true;
              accessibilitySettings.stopAnimations = true;
              accessibilitySettings.readMode = true;
              break;
              
            case 'cognitive':
              setFontSize('25', true);
              setLineHeight('1.8', true);
              setLetterSpacing('2', true);
              document.body.classList.add('accessibility-readable-font');
              accessibilitySettings.readableFont = true;
              break;
              
            case 'vision':
              setFontSize('30', true);
              setContrast('high', true);
              document.body.classList.add('accessibility-readable-font');
              document.body.classList.add('accessibility-underline-links');
              document.body.classList.add('accessibility-big-cursor-black');
              accessibilitySettings.readableFont = true;
              accessibilitySettings.underlineLinks = true;
              break;
          }
          
          saveSettings();
          updateUIState();
        }

              // Font Size
              function setFontSize(size, skipSave = false) {
                document.body.classList.remove(
                  'accessibility-font-size-20',
                  'accessibility-font-size-25',
                  'accessibility-font-size-30',
                  'accessibility-font-size-35'
                );
                if (size !== 'default') {
                  document.body.classList.add(`accessibility-font-size-${size}`);
                }
                accessibilitySettings.fontSize = size;
                if (!skipSave) {
                  saveSettings();
                  updateUIState();
                }
              }

              // Letter Spacing
              function setLetterSpacing(spacing, skipSave = false) {
                document.body.classList.remove(
                  'accessibility-letter-spacing-1',
                  'accessibility-letter-spacing-2',
                  'accessibility-letter-spacing-3',
                  'accessibility-letter-spacing-4'
                );
                if (spacing !== 'normal') {
                  document.body.classList.add(`accessibility-letter-spacing-${spacing}`);
                }
                accessibilitySettings.letterSpacing = spacing;
                if (!skipSave) {
                  saveSettings();
                  updateUIState();
                }
              }

              // Line Height
              function setLineHeight(height, skipSave = false) {
                document.body.classList.remove(
                  'accessibility-line-height-1-5',
                  'accessibility-line-height-1-8',
                  'accessibility-line-height-2'
                );
                if (height !== 'normal') {
                  document.body.classList.add(`accessibility-line-height-${height.replace('.', '-')}`);
                }
                accessibilitySettings.lineHeight = height;
                if (!skipSave) {
                  saveSettings();
                  updateUIState();
                }
              }

              // Text Alignment
              function setTextAlign(align, skipSave = false) {
                document.body.classList.remove(
                  'accessibility-text-align-left',
                  'accessibility-text-align-center',
                  'accessibility-text-align-right',
                  'accessibility-text-align-justify'
                );
                if (align !== 'default') {
                  document.body.classList.add(`accessibility-text-align-${align}`);
                }
                accessibilitySettings.textAlign = align;
                if (!skipSave) {
                  saveSettings();
                  updateUIState();
                }
              }

              // Text Color
              function setTextColor(color, skipSave = false) {
                const style = document.getElementById('custom-text-color') || document.createElement('style');
                style.id = 'custom-text-color';
                if (color === 'default') {
                  style.textContent = '';
                } else {
                  style.textContent = `body:not(.accessibility-widget) *, body:not(.accessibility-widget) *:not(.accessibility-widget *) { color: ${color} !important; }`;
                }
                if (!document.getElementById('custom-text-color')) {
                  document.head.appendChild(style);
                }
                accessibilitySettings.textColor = color;
                if (!skipSave) {
                  saveSettings();
                  updateUIState();
                }
              }

              // Title Color
              function setTitleColor(color, skipSave = false) {
                const style = document.getElementById('custom-title-color') || document.createElement('style');
                style.id = 'custom-title-color';
                if (color === 'default') {
                  style.textContent = '';
                } else {
                  style.textContent = `body h1, body h2, body h3, body h4, body h5, body h6 { color: ${color} !important; }`;
                }
                if (!document.getElementById('custom-title-color')) {
                  document.head.appendChild(style);
                }
                accessibilitySettings.titleColor = color;
                if (!skipSave) {
                  saveSettings();
                  updateUIState();
                }
              }

              // Background Color
              function setBackgroundColor(color, skipSave = false) {
                const style = document.getElementById('custom-bg-color') || document.createElement('style');
                style.id = 'custom-bg-color';
                if (color === 'default') {
                  style.textContent = '';
                } else {
                  style.textContent = `body:not(.accessibility-widget) { background-color: ${color} !important; }`;
                }
                if (!document.getElementById('custom-bg-color')) {
                  document.head.appendChild(style);
                }
                accessibilitySettings.backgroundColor = color;
                if (!skipSave) {
                  saveSettings();
                  updateUIState();
                }
              }

              // Color Vision
              function setColorVision(vision, skipSave = false) {
                document.body.classList.remove(
                  'accessibility-protanopia',
                  'accessibility-deuteranopia',
                  'accessibility-tritanopia'
                );
                if (vision !== 'none') {
                  document.body.classList.add(`accessibility-${vision}`);
                }
                accessibilitySettings.colorVision = vision;
                if (!skipSave) {
                  saveSettings();
                  updateUIState();
                }
              }

              // Contrast
              function setContrast(contrast, skipSave = false) {
                document.body.classList.remove(
                  'accessibility-dark-contrast',
                  'accessibility-light-contrast',
                  'accessibility-high-contrast'
                );
                if (contrast !== 'normal') {
                  document.body.classList.add(`accessibility-${contrast}-contrast`);
                }
                accessibilitySettings.contrast = contrast;
                if (!skipSave) {
                  saveSettings();
                  updateUIState();
                }
              }

              // Saturation
              function setSaturation(saturation, skipSave = false) {
                document.body.classList.remove(
                  'accessibility-high-saturation',
                  'accessibility-low-saturation',
                  'accessibility-monochrome'
                );
                if (saturation !== 'normal') {
                  document.body.classList.add(
                    `accessibility-${saturation === 'monochrome' ? 'monochrome' : saturation + '-saturation'}`
                  );
                }
                accessibilitySettings.saturation = saturation;
                if (!skipSave) {
                  saveSettings();
                  updateUIState();
                }
              }

              // Cursor
              function setCursor(cursor, skipSave = false) {
                document.body.classList.remove('accessibility-big-cursor-black', 'accessibility-big-cursor-white');
                if (cursor !== 'default') {
                  document.body.classList.add(`accessibility-big-cursor-${cursor}`);
                }
                accessibilitySettings.cursor = cursor;
                if (!skipSave) {
                  saveSettings();
                  updateUIState();
                }
              }

              // Toggle Functions
              function toggleReadingLine() {
                if (accessibilitySettings.readingLine) {
                  disableReadingLine();
                  accessibilitySettings.readingLine = false;
                } else {
                  enableReadingLine();
                  accessibilitySettings.readingLine = true;
                }
                saveSettings();
                updateUIState();
              }

              function enableReadingLine() {
                const readingLine = document.getElementById('readingLine');
                readingLine.classList.add('active');
                document.addEventListener('mousemove', updateReadingLine);
              }

              function disableReadingLine() {
                const readingLine = document.getElementById('readingLine');
                readingLine.classList.remove('active');
                document.removeEventListener('mousemove', updateReadingLine);
              }

              function updateReadingLine(e) {
                const readingLine = document.getElementById('readingLine');
                readingLine.style.top = e.clientY - 2 + 'px';
              }

              function toggleReadingGuide() {
                if (accessibilitySettings.readingGuide) {
                  disableReadingGuide();
                  accessibilitySettings.readingGuide = false;
                } else {
                  enableReadingGuide();
                  accessibilitySettings.readingGuide = true;
                }
                saveSettings();
                updateUIState();
              }

              function enableReadingGuide() {
                const guide = document.getElementById('readingGuide');
                guide.classList.add('active');
                document.addEventListener('mousemove', updateReadingGuide);
              }

              function disableReadingGuide() {
                const guide = document.getElementById('readingGuide');
                guide.classList.remove('active');
                document.removeEventListener('mousemove', updateReadingGuide);
              }

              function updateReadingGuide(e) {
                const guide = document.getElementById('readingGuide');
                guide.style.top = e.clientY - 40 + 'px';
              }

              function toggleReadingMask() {
                if (accessibilitySettings.readingMask) {
                  disableReadingMask();
                  accessibilitySettings.readingMask = false;
                } else {
                  enableReadingMask();
                  accessibilitySettings.readingMask = true;
                }
                saveSettings();
                updateUIState();
              }

              function enableReadingMask() {
                const mask = document.getElementById('readingMask');
                mask.classList.add('active');
                document.addEventListener('mousemove', updateReadingMask);
              }

              function disableReadingMask() {
                const mask = document.getElementById('readingMask');
                mask.classList.remove('active');
                document.removeEventListener('mousemove', updateReadingMask);
              }

              function updateReadingMask(e) {
                const mask = document.getElementById('readingMask');
                const maskHeight = 120;
                const top = Math.max(0, e.clientY - maskHeight / 2);
                const bottom = Math.max(0, window.innerHeight - e.clientY - maskHeight / 2);
                mask.style.setProperty('--mask-top', top + 'px');
                mask.style.setProperty('--mask-bottom', bottom + 'px');
              }

              function toggleTextMagnifier() {
                if (accessibilitySettings.textMagnifier) {
                  disableTextMagnifier();
                  accessibilitySettings.textMagnifier = false;
                } else {
                  enableTextMagnifier();
                  accessibilitySettings.textMagnifier = true;
                }
                saveSettings();
                updateUIState();
              }

              function enableTextMagnifier() {
                const magnifier = document.getElementById('textMagnifier');
                magnifier.classList.add('active');
                document.addEventListener('mousemove', updateTextMagnifier);
              }

              function disableTextMagnifier() {
                const magnifier = document.getElementById('textMagnifier');
                magnifier.classList.remove('active');
                document.removeEventListener('mousemove', updateTextMagnifier);
              }

              function updateTextMagnifier(e) {
                const magnifier = document.getElementById('textMagnifier');
                const element = document.elementFromPoint(e.clientX, e.clientY);
                if (element && element.textContent.trim() && !element.closest('.accessibility-widget')) {
                  const text = element.textContent.trim().substring(0, 50);
                  magnifier.textContent = text;
                  magnifier.style.left = e.clientX + 20 + 'px';
                  magnifier.style.top = e.clientY + 20 + 'px';
                }
              }

              function toggleReadableFont() {
                if (accessibilitySettings.readableFont) {
                  disableReadableFont();
                  accessibilitySettings.readableFont = false;
                } else {
                  enableReadableFont();
                  accessibilitySettings.readableFont = true;
                }
                saveSettings();
                updateUIState();
              }

              function enableReadableFont() {
                document.body.classList.add('accessibility-readable-font');
              }

              function disableReadableFont() {
                document.body.classList.remove('accessibility-readable-font');
              }

              function toggleUnderlineLinks() {
                if (accessibilitySettings.underlineLinks) {
                  disableUnderlineLinks();
                  accessibilitySettings.underlineLinks = false;
                } else {
                  enableUnderlineLinks();
                  accessibilitySettings.underlineLinks = true;
                }
                saveSettings();
                updateUIState();
              }

              function enableUnderlineLinks() {
                document.body.classList.add('accessibility-underline-links');
              }

              function disableUnderlineLinks() {
                document.body.classList.remove('accessibility-underline-links');
              }

              function toggleHighlightTitles() {
                if (accessibilitySettings.highlightTitles) {
                  disableHighlightTitles();
                  accessibilitySettings.highlightTitles = false;
                } else {
                  enableHighlightTitles();
                  accessibilitySettings.highlightTitles = true;
                }
                saveSettings();
                updateUIState();
              }

              function enableHighlightTitles() {
                document.body.classList.add('accessibility-highlight-titles');
              }

              function disableHighlightTitles() {
                document.body.classList.remove('accessibility-highlight-titles');
              }

              function toggleHighlightLinks() {
                if (accessibilitySettings.highlightLinks) {
                  disableHighlightLinks();
                  accessibilitySettings.highlightLinks = false;
                } else {
                  enableHighlightLinks();
                  accessibilitySettings.highlightLinks = true;
                }
                saveSettings();
                updateUIState();
              }

              function enableHighlightLinks() {
                document.body.classList.add('accessibility-highlight-links');
              }

              function disableHighlightLinks() {
                document.body.classList.remove('accessibility-highlight-links');
              }

              function toggleHighlightHover() {
                if (accessibilitySettings.highlightHover) {
                  disableHighlightHover();
                  accessibilitySettings.highlightHover = false;
                } else {
                  enableHighlightHover();
                  accessibilitySettings.highlightHover = true;
                }
                saveSettings();
                updateUIState();
              }

              function enableHighlightHover() {
                document.body.classList.add('accessibility-highlight-hover');
              }

              function disableHighlightHover() {
                document.body.classList.remove('accessibility-highlight-hover');
              }

              function toggleHighlightFocus() {
                if (accessibilitySettings.highlightFocus) {
                  disableHighlightFocus();
                  accessibilitySettings.highlightFocus = false;
                } else {
                  enableHighlightFocus();
                  accessibilitySettings.highlightFocus = true;
                }
                saveSettings();
                updateUIState();
              }

              function enableHighlightFocus() {
                document.body.classList.add('accessibility-highlight-focus');
              }

              function disableHighlightFocus() {
                document.body.classList.remove('accessibility-highlight-focus');
              }

              function toggleStopAnimations() {
                if (accessibilitySettings.stopAnimations) {
                  disableStopAnimations();
                  accessibilitySettings.stopAnimations = false;
                } else {
                  enableStopAnimations();
                  accessibilitySettings.stopAnimations = true;
                }
                saveSettings();
                updateUIState();
              }

              function enableStopAnimations() {
                document.body.classList.add('accessibility-stop-animations');
              }

              function disableStopAnimations() {
                document.body.classList.remove('accessibility-stop-animations');
              }

              function toggleMuteSounds() {
                if (accessibilitySettings.muteSounds) {
                  disableMuteSounds();
                  accessibilitySettings.muteSounds = false;
                } else {
                  enableMuteSounds();
                  accessibilitySettings.muteSounds = true;
                }
                saveSettings();
                updateUIState();
              }

              function enableMuteSounds() {
                document.body.classList.add('accessibility-mute-sounds');
                document.querySelectorAll('audio, video').forEach((el) => {
                  el.muted = true;
                });
              }

              function disableMuteSounds() {
                document.body.classList.remove('accessibility-mute-sounds');
                document.querySelectorAll('audio, video').forEach((el) => {
                  el.muted = false;
                });
              }

              function toggleHideImages() {
                if (accessibilitySettings.hideImages) {
                  disableHideImages();
                  accessibilitySettings.hideImages = false;
                } else {
                  enableHideImages();
                  accessibilitySettings.hideImages = true;
                }
                saveSettings();
                updateUIState();
              }

              function enableHideImages() {
                document.body.classList.add('accessibility-hide-images');
              }

              function disableHideImages() {
                document.body.classList.remove('accessibility-hide-images');
              }

              function toggleReadMode() {
                if (accessibilitySettings.readMode) {
                  disableReadMode();
                  accessibilitySettings.readMode = false;
                } else {
                  enableReadMode();
                  accessibilitySettings.readMode = true;
                }
                saveSettings();
                updateUIState();
              }

              function enableReadMode() {
                document.body.classList.add('accessibility-read-mode');
              }

              function disableReadMode() {
                document.body.classList.remove('accessibility-read-mode');
              }

              // Text to Speech Functions
              function toggleTextToSpeech() {
                if (accessibilitySettings.textToSpeech) {
                  disableTextToSpeech();
                  accessibilitySettings.textToSpeech = false;
                } else {
                  enableTextToSpeech();
                  accessibilitySettings.textToSpeech = true;
                }
                saveSettings();
                updateUIState();
              }

              function enableTextToSpeech() {
                ttsEnabled = true;
                document.getElementById('ttsControls').classList.add('active');
              }

              function disableTextToSpeech() {
                ttsEnabled = false;
                stopTTS();
                document.getElementById('ttsControls').classList.remove('active');
              }

              function playTTS() {
                if (!ttsEnabled) return;

                if (window.speechSynthesis.speaking && window.speechSynthesis.paused) {
                  window.speechSynthesis.resume();
                  return;
                }

                const textContent = document.body.innerText.replace(/\s+/g, ' ').trim();
                ttsUtterance = new SpeechSynthesisUtterance(textContent);
                ttsUtterance.rate = 1;
                ttsUtterance.pitch = 1;
                ttsUtterance.volume = 1;

                window.speechSynthesis.speak(ttsUtterance);
              }

              function pauseTTS() {
                if (window.speechSynthesis.speaking) {
                  window.speechSynthesis.pause();
                }
              }

              function stopTTS() {
                window.speechSynthesis.cancel();
              }

              // Keyboard Shortcuts
              function toggleKeyboardShortcuts() {
                accessibilitySettings.keyboardShortcuts = !accessibilitySettings.keyboardShortcuts;
                saveSettings();
                updateUIState();
              }

              function showKeyboardShortcuts() {
                document.getElementById('shortcutsModal').classList.add('active');
                document.querySelector('.sidebar-overlay').classList.add('active');
              }

              function hideKeyboardShortcuts() {
                document.getElementById('shortcutsModal').classList.remove('active');
                if (!document.querySelector('.accessibility-sidebar').classList.contains('open')) {
                  document.querySelector('.sidebar-overlay').classList.remove('active');
                }
              }

              function resetAllSettings() {
                accessibilitySettings = {
                  fontSize: 'default',
                  letterSpacing: 'normal',
                  lineHeight: 'normal',
                  textAlign: 'default',
                  textColor: 'default',
                  titleColor: 'default',
                  backgroundColor: 'default',
                  colorVision: 'none',
                  contrast: 'normal',
                  saturation: 'normal',
                  cursor: 'default',
                  readingLine: false,
                  readingGuide: false,
                  readingMask: false,
                  textMagnifier: false,
                  readableFont: false,
                  underlineLinks: false,
                  highlightTitles: false,
                  highlightLinks: false,
                  highlightHover: false,
                  highlightFocus: false,
                  stopAnimations: false,
                  muteSounds: false,
                  hideImages: false,
                  readMode: false,
                  textToSpeech: false,
                  keyboardShortcuts: true,
                  activeProfile: null,
                };

                document.body.className = '';
                disableReadingLine();
                disableReadingGuide();
                disableReadingMask();
                disableTextMagnifier();
                disableTextToSpeech();

                // Remove custom styles
                ['custom-text-color', 'custom-title-color', 'custom-bg-color'].forEach((id) => {
                  const style = document.getElementById(id);
                  if (style) style.remove();
                });

                try {
                  localStorage.removeItem('kwikpets_accessibility_settings');
                } catch (e) {
                  console.warn('Could not clear accessibility settings');
                }

                updateUIState();
              }

              function initializeAccessibilityWidget() {
                loadSettings();

                document.addEventListener('keydown', function (e) {
                  if (!accessibilitySettings.keyboardShortcuts) return;

                  // ESC - Close
                  if (e.key === 'Escape') {
                    closeAccessibilitySidebar();
                    hideKeyboardShortcuts();
                  }

                  // ALT + A - Open Menu
                  if (e.altKey && e.key.toLowerCase() === 'a') {
                    e.preventDefault();
                    toggleAccessibilitySidebar();
                  }

                  // ALT + 1-6 - Profiles
                  if (e.altKey && e.key >= '1' && e.key <= '6') {
                    e.preventDefault();
                    const profiles = ['reader', 'blind', 'seizure', 'adhd', 'cognitive', 'vision'];
                    applyProfile(profiles[parseInt(e.key) - 1]);
                  }

                  // CTRL + R - Read Mode
                  if (e.ctrlKey && e.key.toLowerCase() === 'r') {
                    e.preventDefault();
                    toggleReadMode();
                  }

                  // TAB - Text to Speech (only if enabled)
                  if (e.key === 'Tab' && ttsEnabled && !e.shiftKey && !e.ctrlKey && !e.altKey) {
                    e.preventDefault();
                    playTTS();
                  }
                });

                // Handle page navigation
                let currentUrl = window.location.href;
                const observer = new MutationObserver(function () {
                  if (window.location.href !== currentUrl) {
                    currentUrl = window.location.href;
                    setTimeout(() => {
                      applyAllSettings();
                    }, 100);
                  }
                });

                observer.observe(document.body, {
                  childList: true,
                  subtree: true,
                });

                console.log('KwikPets Complete Accessibility Widget initialized');
              }

              if (document.readyState === 'loading') {
                document.addEventListener('DOMContentLoaded', initializeAccessibilityWidget);
              } else {
                initializeAccessibilityWidget();
              }

              window.addEventListener('load', function () {
                setTimeout(initializeAccessibilityWidget, 100);
              });



// Product Judge me rounding code
(function () {
  function roundHalf(n) {
    return Math.round(n * 2) / 2; // 4.95 -> 5, 4.4 -> 4.5, 4.2 -> 4
  }

  function fixRating() {
    // The number text
    document
      .querySelectorAll('.jm-average-rating-display p.jm-text:not(.jm-average-rating-display__review-count)')
      .forEach(function (el) {
        var val = parseFloat(el.textContent);
        if (isNaN(val)) return;
        var rounded = roundHalf(val).toFixed(1); // use String(roundHalf(val)) for "5" instead of "5.0"
        if (el.textContent.trim() !== rounded) el.textContent = rounded;
      });

    // Keep the accessibility label consistent
    document.querySelectorAll('.jm-star-rating[aria-label]').forEach(function (el) {
      var m = el.getAttribute('aria-label').match(/^(\d+(\.\d+)?) out of 5/);
      if (!m) return;
      var label = roundHalf(parseFloat(m[1])).toFixed(1) + ' out of 5 stars';
      if (el.getAttribute('aria-label') !== label) el.setAttribute('aria-label', label);
    });
  }

  // Judge.me loads late, so watch for the widget rendering
  var timer;
  new MutationObserver(function () {
    clearTimeout(timer);
    timer = setTimeout(fixRating, 50);
  }).observe(document.body, { childList: true, subtree: true, characterData: true });

  document.addEventListener('DOMContentLoaded', fixRating);
})();